import service from "../Services/service";
export async function DashboardGetbyIdhooks(id) {
    var data;
    await service.getdatabyId("Dashboard/GetById?id=",id).then((res) => {
        data = res.data;
    });
    return data;
}

export async function CalendarEvent(id) {
    var data;
    await service.getdatabyId("Dashboard/CalendarEvent?id=",id).then((res) => {
        data = res.data;
    });
    return data;
}